// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"79c0b1c8","341":"d04918e4","438":"387cc76a","706":"df677275","726":"b6cb67d6","785":"9bf5894f"}[chunkId] + ".chunk.js";
};